<template>
  <div
    class="videofiles"
    @scroll="scroll"
    :style="{ gridTemplateColumns: `repeat(${this.configs.parameters['Columns']}, 1fr)` }"
  >
    <div class="image" v-for="(item, index) in fieldsData" :key="index" @click="openVideo(item)">
      <h3>{{ item.text }}</h3>
      <img :src="item.image" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardVideofiles',
  props: {
    id: {
      type: String
    },
    dashboardId: {
      type: String
    },
    items: {
      type: Array,
      default() {
        return []
      }
    },
    configs: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      fieldsData: []
    }
  },
  mounted() {
    this.rerender()
    this.fieldsData = [...this.items]
  },
  watch: {
    configs: {
      deep: true,
      immediate: true,
      handler: 'rerender'
    }
  },
  methods: {
    rerender() {
      this.$forceUpdate()
    },
    scroll(event) {
      if (this.loading) {
        return
      }
      const { target } = event
      if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
        const body = {
          dashboard_id: this.dashboardId,
          element_id: this.id.replace(this.temp, ''),
          last_row: Math.trunc(this.fieldsData.length / this.configs.parameters['Columns'])
        }
        const searchParams = new URLSearchParams(body)
        const url = `${process.env.VUE_APP_API_ENDPOINT ||
          window.location.origin}/api/ui_element/get_next_video_chunks?${searchParams}`
        this.loading = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.fieldsData.push(...data)
            this.$forceUpdate()
          })
          .catch(error =>
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          )
          .finally(() => {
            this.loading = false
          })
      }
    },
    openVideo(item) {
      const a = document.createElement('a')
      a.setAttribute('target', '_blank')
      a.href = `/video?video_data=${JSON.stringify(item.video)}`
      a.click()
    }
  }
}
</script>

<style lang="scss">
.videofiles {
  display: grid;
  grid-gap: 1rem;
  overflow: scroll;
  width: 100%;
  height: 100%;
  padding-top: 0;
  padding-bottom: 0;
  .image {
    &:hover {
      cursor: pointer;
      h3 {
        text-decoration: underline;
      }
    }
  }
  .apply {
    justify-content: right;
    display: flex;
  }
  .loadmore {
    grid-column: 1/4;
  }
}
</style>
